import React from "react";
import { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from 'swiper'
import { GaleryConfig } from "../../constants";

const Galery = () => {
    return (
        <section id="galery" className="mt-4 overflow-hidden">
            <div className="galery-header flex justify-center">
                <h1 className="text-3xl font-bold text-primary">Galery</h1>
            </div>
            <div className="galery-swiper">
                <Swiper pagination={{ 
                    dynamicBullets: true
                }} modules={ [Pagination] } loop={true} autoplay={true} className='mySwiper'>
                    {
                        GaleryConfig.galery.map((value, index) => (
                            <SwiperSlide>
                                <div className="p-4">
                                    <div className="shadow-xl flex justify-center">
                                        <div className="w-full h-full bg-primary max-h-[280px] bg-center sm:max-w-[400px] sm:max-h-[400px]">
                                            <img src={ require(`../../assets/img/${value.image}`) } alt="Galery Image" className="bg-light rounded-md"/>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </section>
    )
}

export default Galery